(function () {
  var STORAGE_KEY = 'recipe-steps:' + window.location.pathname;

  function getSteps() {
    var container = document.querySelector('.recept--text-bereidingswijze .metafield-rich_text_field');
    if (!container) {
      return [];
    }

    var elements = Array.from(container.querySelectorAll('p, li'));
    return elements.filter(function (el) {
      return el.textContent.trim() !== '';
    });
  }

  function loadState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function saveState(state) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function toggleStep(el, index, state) {
    var isDone = el.classList.contains('step--done');

    if (isDone) {
      el.classList.remove('step--done');
      el.setAttribute('aria-checked', 'false');
      delete state[index];
    } else {
      el.classList.add('step--done');
      el.setAttribute('aria-checked', 'true');
      state[index] = true;
    }

    saveState(state);
  }

  function init() {
    var steps = getSteps();
    if (steps.length === 0) {
      return;
    }

    var state = loadState();

    steps.forEach(function (el, index) {
      el.setAttribute('data-step-index', index);
      el.setAttribute('role', 'checkbox');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-checked', state[index] ? 'true' : 'false');

      if (state[index]) {
        el.classList.add('step--done');
      }

      el.addEventListener('click', function () {
        toggleStep(el, index, state);
      });

      el.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          toggleStep(el, index, state);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
